import { createActions, createReducer } from "reduxsauce";
import { onChangeFieldValue } from "utils/functions/";
import { defaultState } from "./document-model";

// actions
export const { Types, Creators } = createActions({
  documentShowLoading: [],
  documentHideLoading: [],
  documentShowLoadingTable: [],
  documentHideLoadingTable: [],
  documentShowDrawerNewDocument: [],
  documentHideDrawerNewDocument: [],
  documentShowDrawerEditDocument: [],
  documentHideDrawerEditDocument: [],
  documentUpdateFormModified: ["formEditModified"],
  documentRegistersActive: ["items", "totalItems"],
  documentChangeFieldValue: ["fieldName", "value"],
  documentUpdateDocument: ["editDocument"],
  documentUpdateFilter: ["filter"],
  documentEnabledRegisterButton: [],
  documentDisabledRegisterButton: [],
  documentMaskAllowLetterActive: ["maskAllowLetters"],
  documentIdActive: ["documentId"],
  documentMaskAllowNumberActive: ["maskAllowNumbers"],
  documentMaskAllowSpecialCharactersActive: ["maskAllowSpecialCharacters"],
  documentMaskMinCharactersActive: ["maskMinCharacters"],
  documentMaskMaxCharactersActive: ["maskMaxCharacters"],
  documentClearMaskDocuments: [],
  documentFetchAllActivesAsync: [],
  documentSaveNewDocumentAsync: ["body"],
  documentDeleteByIdAsync: ["body"],
  documentUpdateDocumentAsync: ["body"],
  documentFetchByIdAsync: ["id"],
});

export const showLoading = (state = defaultState) => ({
  ...state,
  isLoading: true,
});

export const hideLoading = (state = defaultState) => ({
  ...state,
  isLoading: false,
});

export const showLoadingTable = (state = defaultState) => ({
  ...state,
  isLoadingTable: true,
});

export const hideLoadingTable = (state = defaultState) => ({
  ...state,
  isLoadingTable: false,
});

export const disabledRegisterButton = (state = defaultState) => ({
  ...state,
  disabledButton: true,
});

export const enableRegisterButton = (state = defaultState) => ({
  ...state,
  disabledButton: false,
});

export const registerActive = (state, { items, totalItems }) => ({
  ...state,
  items,
  totalItems,
});

export const changeFieldValue = (state, { fieldName, value }) => ({
  ...state,
  filter: onChangeFieldValue(state.filter, fieldName, value),
});

export const showDrawerDocument = (state = defaultState) => ({
  ...state,
  visibleDrawerNewDocument: true,
});

export const hideDrawerDocument = (state = defaultState) => ({
  ...state,
  visibleDrawerNewDocument: false,
});

export const showDrawerEditDocument = (state = defaultState) => ({
  ...state,
  visibleDrawerEditDocument: true,
});

export const hideDrawerEditDocument = (state = defaultState) => ({
  ...state,
  visibleDrawerEditDocument: false,
});

export const updateFilter = (state, action: any) => {
  return {
    ...state,
    searchFilter: action.filter,
  };
};
export const updateMaskAllowLetters = (state, action: any) => ({
  ...state,
  maskAllowLetters: action.maskAllowLetters,
});

export const updateMaskAllowNumbers = (state, action: any) => ({
  ...state,
  maskAllowNumbers: action.maskAllowNumbers,
});

export const updateMaskAllowSpecialCharacters = (state, action: any) => ({
  ...state,
  maskAllowSpecialCharacters: action.maskAllowSpecialCharacters,
});

export const updateMaskMinCharacters = (state, action: any) => ({
  ...state,
  maskMinCharacters: action.maskMinCharacters,
});

export const updateMaskMaxCharacters = (state, action: any) => ({
  ...state,
  maskMaxCharacters: action.maskMaxCharacters,
});

export const updateDocumentId = (state, action: any) => ({
  ...state,
  documentId: action.documentId,
});

export const clearMaskDocuments = (state = defaultState) => ({
  ...state,
  maskAllowLetters: true,
  maskAllowNumbers: true,
  maskAllowSpecialCharacters: true,
  maskMinCharacters: 0,
  maskMaxCharacters: 100,
});

export const editDocument = (state, action: any) => ({
  ...state,
  editDocument: action.editDocument,
});

export const updateformEditModified = (state, action: any) => ({
  ...state,
  formEditModified: action.formEditModified,
});

// map reducer to action
export default createReducer(defaultState, {
  [Types.DOCUMENT_SHOW_LOADING]: showLoading,
  [Types.DOCUMENT_HIDE_LOADING]: hideLoading,
  [Types.DOCUMENT_SHOW_LOADING_TABLE]: showLoadingTable,
  [Types.DOCUMENT_HIDE_LOADING_TABLE]: hideLoadingTable,
  [Types.DOCUMENT_DISABLED_REGISTER_BUTTON]: disabledRegisterButton,
  [Types.DOCUMENT_ENABLED_REGISTER_BUTTON]: enableRegisterButton,
  [Types.DOCUMENT_REGISTERS_ACTIVE]: registerActive,
  [Types.DOCUMENT_CHANGE_FIELD_VALUE]: changeFieldValue,
  [Types.DOCUMENT_HIDE_DRAWER_NEW_DOCUMENT]: hideDrawerDocument,
  [Types.DOCUMENT_SHOW_DRAWER_NEW_DOCUMENT]: showDrawerDocument,
  [Types.DOCUMENT_HIDE_DRAWER_EDIT_DOCUMENT]: hideDrawerEditDocument,
  [Types.DOCUMENT_SHOW_DRAWER_EDIT_DOCUMENT]: showDrawerEditDocument,
  [Types.DOCUMENT_UPDATE_FILTER]: updateFilter,
  [Types.DOCUMENT_MASK_ALLOW_LETTER_ACTIVE]: updateMaskAllowLetters,
  [Types.DOCUMENT_MASK_ALLOW_NUMBER_ACTIVE]: updateMaskAllowNumbers,
  [Types.DOCUMENT_MASK_ALLOW_SPECIAL_CHARACTERS_ACTIVE]: updateMaskAllowSpecialCharacters,
  [Types.DOCUMENT_ID_ACTIVE]: updateDocumentId,
  [Types.DOCUMENT_MASK_MIN_CHARACTERS_ACTIVE]: updateMaskMinCharacters,
  [Types.DOCUMENT_MASK_MAX_CHARACTERS_ACTIVE]: updateMaskMaxCharacters,
  [Types.DOCUMENT_CLEAR_MASK_DOCUMENTS]: clearMaskDocuments,
  [Types.DOCUMENT_UPDATE_DOCUMENT]: editDocument,
  [Types.DOCUMENT_UPDATE_FORM_MODIFIED]: updateformEditModified,
});
